"use strict";
/**
 *
 * Divider
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("../styles");
const styles = styles_1.createStyles(({ spacing }) => ({
    root: {
        margin: spacing(1, 0),
        borderStyle: 'solid',
        borderBottom: 0,
        opacity: 0.6,
    },
}));
const Divider = react_1.default.forwardRef(function Divider(props, ref) {
    const { children, theme, classes, className, color = 'textSecondary', weight = 'thin', style } = props, rest = __rest(props, ["children", "theme", "classes", "className", "color", "weight", "style"]);
    function deriveStyle() {
        return Object.assign({ borderColor: theme.palette[color], borderWidth: weight === 'thin' ? 1 : 2 }, style);
    }
    return (react_1.default.createElement("hr", Object.assign({}, rest, { ref: ref, className: clsx_1.default(classes.root, className), style: deriveStyle() })));
});
if (process.env.NODE_ENV !== 'production') {
    Divider.displayName = 'Divider';
}
const StyledDivider = styles_1.withStyles(styles, { injectTheme: true })(Divider);
exports.Divider = StyledDivider;
